import React from 'react';

const CanadaFlag = (props) => (
  <svg id="b" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 225 150" {...props}>
    <g id="c">
      <rect width="225" height="150" fill="red" strokeWidth="0" />
      <rect x="56.25" width="112.5" height="150" fill="#fff" strokeWidth="0" />
      <path
        d="M112.5,28.1l-7.96,14.85c-.9,1.61-2.52,1.46-4.14.56l-5.77-2.99,4.3,22.82c.9,4.17-2,4.17-3.43,2.37l-10.06-11.27-1.63,5.72c-.19.75-1.02,1.54-2.26,1.35l-12.72-2.68,3.34,12.15c.72,2.7,1.27,3.82-.72,4.54l-4.54,2.13,21.9,17.79c.87.67,1.31,1.88,1,2.98l-1.92,6.29c7.54-.87,14.3-2.18,21.85-2.98.67-.07,1.78,1.03,1.78,1.8l-1,23.05h3.67l-.58-23c0-.77,1.01-1.92,1.67-1.85,7.55.81,14.3,2.11,21.85,2.98l-1.92-6.29c-.31-1.1.13-2.31,1-2.98l21.9-17.79-4.54-2.13c-2-.71-1.44-1.83-.72-4.54l3.34-12.15-12.72,2.68c-1.24.19-2.07-.6-2.26-1.35l-1.63-5.72-10.06,11.27c-1.43,1.8-4.33,1.8-3.43-2.37l4.3-22.82-5.77,2.99c-1.62.9-3.24,1.05-4.14-.56l-7.97-14.85Z"
        fill="red"
        strokeWidth="0"
      />
    </g>
  </svg>
);

const MexicoFlag = (props) => (
  <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 225 150" {...props}>
    <rect fill="#ce1126" width="225" height="150" />
    <rect fill="#fff" x="75" width="75" height="150" />
    <rect fill="#006847" width="75" height="150" />
    <g transform="translate(112.5, 75) scale(0.5)">
      <circle fill="#fcca3e" stroke="#aa8c30" strokeWidth="1" r="20" />
      <path fill="#6c4119" d="M-10,-5 L10,-5 L0,15 Z" />
    </g>
  </svg>
);

const USFlag = (props) => (
  <svg id="b" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 225 150" {...props}>
    <rect width="225" height="150" fill="#b50900" />
    <path d="M225,11.54H0v11.54H225V11.54ZM225,34.62H0v11.54H225V34.62ZM225,57.69H0v11.54H225V57.69ZM225,80.77H0v11.54H225V80.77ZM225,103.85H0v11.54H225V103.85ZM225,126.92H0v11.54H225V126.92Z" fill="#fff" />
    <rect width="108.3" height="81.3" fill="#2b1d73" />
    <g fill="#fff">
      <circle cx="10" cy="10" r="2" />
      <circle cx="30" cy="10" r="2" />
      <circle cx="50" cy="10" r="2" />
      <circle cx="70" cy="10" r="2" />
      <circle cx="90" cy="10" r="2" />
      <circle cx="20" cy="25" r="2" />
      <circle cx="40" cy="25" r="2" />
      <circle cx="60" cy="25" r="2" />
      <circle cx="80" cy="25" r="2" />
      <circle cx="100" cy="25" r="2" />
      <circle cx="10" cy="40" r="2" />
      <circle cx="30" cy="40" r="2" />
      <circle cx="50" cy="40" r="2" />
      <circle cx="70" cy="40" r="2" />
      <circle cx="90" cy="40" r="2" />
      <circle cx="20" cy="55" r="2" />
      <circle cx="40" cy="55" r="2" />
      <circle cx="60" cy="55" r="2" />
      <circle cx="80" cy="55" r="2" />
      <circle cx="100" cy="55" r="2" />
      <circle cx="10" cy="70" r="2" />
      <circle cx="30" cy="70" r="2" />
      <circle cx="50" cy="70" r="2" />
      <circle cx="70" cy="70" r="2" />
      <circle cx="90" cy="70" r="2" />
    </g>
  </svg>
);

const Flag = ({ code, className, height = "32px" }) => {
  const flags = {
    CA: CanadaFlag,
    MX: MexicoFlag,
    US: USFlag,
  };

  const FlagComponent = flags[code.toUpperCase()];

  if (!FlagComponent) {
    return null;
  }

  return <FlagComponent className={className} style={{ height }} />;
};

export default Flag;
